/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Notes_DescInputs */

const en_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`writing & thoughts`)
};

const ar_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتابات وأفكار`)
};

const bn_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেখা ও ভাবনা`)
};

const de_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte & Gedanken`)
};

const es_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ideas y artículos`)
};

const fr_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`articles et réflexions`)
};

const pt_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`artigos e ideias`)
};

const zh_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写作和想法`)
};

const tr_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yazı ve düşünceler`)
};

const ru_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`письмо и мысли`)
};

const pl_hero_notes_desc = /** @type {(inputs: Hero_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pisanie i przemyślenia`)
};

/**
* | output |
* | --- |
* | "writing & thoughts" |
*
* @param {Hero_Notes_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_notes_desc = /** @type {((inputs?: Hero_Notes_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Notes_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_notes_desc(inputs)
	if (locale === "bn") return bn_hero_notes_desc(inputs)
	if (locale === "de") return de_hero_notes_desc(inputs)
	if (locale === "es") return es_hero_notes_desc(inputs)
	if (locale === "fr") return fr_hero_notes_desc(inputs)
	if (locale === "pt") return pt_hero_notes_desc(inputs)
	if (locale === "zh") return zh_hero_notes_desc(inputs)
	if (locale === "tr") return tr_hero_notes_desc(inputs)
	if (locale === "ru") return ru_hero_notes_desc(inputs)
	if (locale === "pl") return pl_hero_notes_desc(inputs)
	return en_hero_notes_desc(inputs)
});